import axios from '@/http.js';
export const USER_TABLE = 'api/users';
export default {
    getUserInfo () {
        return axios.get(`api/users/uibt`);
    },
    surveysClose () {
        return axios.get('api/surveys/closeRemind')
    },
    editUserInfo (param) {
      return axios.put(`api/users`, param);
    },
    addUser (param) {
      return axios.post(`api/users`, param);
    },
    delUser (param) {
      return axios.delete(`api/users/`, {params: param});
    },
    getProjectUsers(projectId) {
        const url = `api/users/backend?projectId=${projectId}`;
        return axios.get(url);
    },
    saveUserBatch(modifyList, projectId) {
        const url = '/api/users/backend/batchEdit';
        return axios.post(url, {modifyList, projectId});
    },
    getProjectName (projectId) {
      const url = `/api/projects/${projectId}`;
        return axios.get(url);
    },
    getSystemAdminList () {
        const url = `/api/users/list/sys`;
        return axios.get(url);
    },
    delSystemAdminByEmail (email) {
        const url = `/api/users/del/sys`;
        return axios.delete(url,{
            headers:{
                email: email
            }
        });
    },
    addSystemAdmin (data) {
        const url = `/api/users/add/sys`;
        return axios.post(url, data);
    },
    saveUserFirstVisit(){
        const url = '/api/users/graduate';
        return axios.put(url);
    },
    getByIds(ids){
        const url = 'api/users/findByIds';
        return axios.post(url, ids);
    },
    setTopProject(id) {
        const url = `api/users/setTopProject?projectId=${id}`;
        return axios.put(url);
    }
}